﻿import discountComponent from './components/DiscountComponent.vue';

const discountApp = {
    components: { discountComponent }
}

export default discountApp;